import { StreamActions } from '@hotwired/turbo';

Object.assign(StreamActions, {
  close() {
    document.querySelectorAll('dialog:open').forEach((dialog) => {
      dialog.close();
    });
  },
});
